import React from 'react';
import DownloadCard from '../Utilities/DownloadCard';
import { downloadFiles } from '../constants/DownloadFiles';

const Downloads = () => {
  return (
    <div>
      <h1 className='text-4xl font-semibold text-center m-3'>Downloads</h1>
      <hr className="mb-4 border-black border-2 w-96 m-auto"/>
      <div className='bg-gray-300 w-2/3 m-auto p-4 my-4 grid gap-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
        {downloadFiles.map((item, index) => (
          <DownloadCard key={index} name={item.name} file={item.file} />
        ))}
      </div>
    </div>
  );
};

export default Downloads;
